module.exports = __webpack_public_path__ + "img/OandaLogo.e082ba48.png";